import React, { useState, useEffect } from 'react';
import { positionsAPI } from '../../services/api';

const PositionsSettings = () => {
  const [positions, setPositions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editingPosition, setEditingPosition] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    state: true,
    ordering: 0,
    type: 1
  });

  useEffect(() => {
    fetchPositions();
  }, []);

  const fetchPositions = async () => {
    try {
      const response = await positionsAPI.getAll();
      setPositions(response.data.sort((a, b) => a.ordering - b.ordering));
    } catch (err) {
      setError('Failed to fetch positions');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingPosition) {
        await positionsAPI.update(editingPosition._id, formData);
      } else {
        await positionsAPI.create(formData);
      }
      fetchPositions();
      resetForm();
    } catch (err) {
      setError('Failed to save position');
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this position?')) {
      try {
        await positionsAPI.delete(id);
        fetchPositions();
      } catch (err) {
        setError('Failed to delete position');
      }
    }
  };

  const resetForm = () => {
    setFormData({ name: '', state: true, ordering: 0, type: 1 });
    setEditingPosition(null);
    setShowModal(false);
  };

  const handleEdit = (position) => {
    setFormData({
      name: position.name,
      state: position.state,
      ordering: position.ordering,
      type: position.type
    });
    setEditingPosition(position);
    setShowModal(true);
  };

  if (loading) return <div className="loading loading-spinner loading-lg"></div>;

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-bold">Positions</h2>
        <button 
          className="btn btn-primary"
          onClick={() => setShowModal(true)}
        >
          Add Position
        </button>
      </div>

      {error && (
        <div className="alert alert-error">
          <span>{error}</span>
        </div>
      )}

      <div className="overflow-x-auto">
        <table className="table table-zebra w-full">
          <thead>
            <tr>
              <th>Name</th>
              <th>Order</th>
              <th>Type</th>
              <th>State</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(positions) && positions.map((position) => (
              <tr key={position._id}>
                <td>{position.name}</td>
                <td>{position.ordering}</td>                <td>
                  <div className="badge badge-outline">
                    {position.type === 1 ? 'Spieler' : 'Betreuer'}
                  </div>
                </td>
                <td>
                  <div className={`badge ${position.state ? 'badge-success' : 'badge-error'}`}>
                    {position.state ? 'Active' : 'Inactive'}
                  </div>
                </td>
                <td>
                  <div className="space-x-2">
                    <button 
                      className="btn btn-sm btn-outline"
                      onClick={() => handleEdit(position)}
                    >
                      Edit
                    </button>
                    <button 
                      className="btn btn-sm btn-error"
                      onClick={() => handleDelete(position._id)}
                    >
                      Delete
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modal */}
      {showModal && (
        <dialog open className="modal">
          <div className="modal-box">
            <h3 className="font-bold text-lg">
              {editingPosition ? 'Edit Position' : 'Add New Position'}
            </h3>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="form-control">
                <label className="label">
                  <span className="label-text">Name</span>
                </label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) => setFormData({...formData, name: e.target.value})}
                  className="input input-bordered"
                  required
                />
              </div>
              <div className="form-control">
                <label className="label">
                  <span className="label-text">Ordering</span>
                </label>
                <input
                  type="number"
                  value={formData.ordering}
                  onChange={(e) => setFormData({...formData, ordering: parseInt(e.target.value) || 0})}
                  className="input input-bordered"
                />
              </div>              <div className="form-control">
                <label className="label">
                  <span className="label-text">Type</span>
                </label>
                <select
                  value={formData.type}
                  onChange={(e) => setFormData({...formData, type: parseInt(e.target.value)})}
                  className="select select-bordered"
                >
                  <option value={1}>Spieler</option>
                  <option value={2}>Betreuer</option>
                </select>
              </div>
              <div className="form-control">
                <label className="label cursor-pointer">
                  <span className="label-text">Active</span>
                  <input
                    type="checkbox"
                    checked={formData.state}
                    onChange={(e) => setFormData({...formData, state: e.target.checked})}
                    className="checkbox"
                  />
                </label>
              </div>
              <div className="modal-action">
                <button type="submit" className="btn btn-primary">
                  {editingPosition ? 'Update' : 'Create'}
                </button>
                <button type="button" className="btn" onClick={resetForm}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </dialog>
      )}
    </div>
  );
};

export default PositionsSettings;
